import React from "react";
import { Link } from "react-router";
import AppButton from "../components/AppButton";

const Home = () => {
	return (
		<div className="p-2">
			<h1 className="text-xl text-zinc-500 font-bold mb-4">Explore Tools</h1>

			<div className="flex gap-3">
				<Link to="./pdf-merge">
					<AppButton title={"Combine PDF"} />
				</Link>

				<Link to="./pdf-organize">
					<AppButton title={"Organize PDF"} />
				</Link>

				<Link to="./pdf-convert">
					<AppButton title={"Convert PDF"} />
				</Link>
			</div>
		</div>
	);
};

export default Home;
